import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { usersRolesTeacher } from '@edtech-ui/constants/users-roles-teachers.enum';

@Component({
	selector: 'app-delete-member-dialog-box',
	standalone: true,
	imports: [],
	templateUrl: './delete-member-dialog-box.component.html',
	styleUrl: './delete-member-dialog-box.component.scss'
})
export class DeleteMemberDialogBoxComponent {
	
	usersRolesTeacher = usersRolesTeacher;

	constructor(public dialogRef: MatDialogRef<DeleteMemberDialogBoxComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { type: usersRolesTeacher }) { }

	onCancel(): void {
		this.dialogRef.close(false);
	}

	onRemove(): void {
		this.dialogRef.close(true);
	}
}
